import * as React from "react";
import type { SVGProps } from "react";
const SvgWeb3DappsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="web3_dapps_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M927.317 386.56a85.333 85.333 0 0 0 0-120.661L791.552 130.133a85.333 85.333 0 0 0-120.661 0L535.125 265.9a85.333 85.333 0 0 0 0 120.661l135.766 135.765a85.333 85.333 0 0 0 120.661 0L927.317 386.56zM731.221 190.464l135.766 135.765L731.22 461.995 595.456 326.229l135.765-135.765zm-560.554-57.301a85.333 85.333 0 0 0-85.334 85.333v192a85.333 85.333 0 0 0 85.334 85.333h163.882A113.45 113.45 0 0 0 448 382.421V218.453a85.333 85.333 0 0 0-85.333-85.333h-192zm0 85.333h192v163.925a28.117 28.117 0 0 1-28.118 28.075H170.667v-192zm0 715.05a85.333 85.333 0 0 1-85.334-85.333v-192a85.333 85.333 0 0 1 85.334-85.333h163.882A113.45 113.45 0 0 1 448 684.33v163.883a85.333 85.333 0 0 1-85.333 85.334h-192zm0-85.333h192V684.331a28.117 28.117 0 0 0-28.118-28.118H170.667v192zm629.674 85.334a85.333 85.333 0 0 0 85.334-85.334v-192a85.333 85.333 0 0 0-85.334-85.333H636.46a113.45 113.45 0 0 0-113.494 113.45v163.883a85.333 85.333 0 0 0 85.334 85.334h192zm0-85.334h-192V684.331c0-15.531 12.587-28.118 28.118-28.118h163.84v192z"
    />
  </svg>
);
export default SvgWeb3DappsIcon;
